export const times = ['5', '10', '15', '20', '25', '30', '40', '50', '60'];
